export default __webpack_public_path__ + "static/media/popup-bg-pc.0f933eb9.jpg";